import { VpIcon } from '@vtmn-play/react/headless';
import classNames from 'classnames';
import { components } from 'react-select';
import { apiTypes } from '~/const/api';

const { Option } = components;

export const IconOption = (props) => {
  const isSelected = props.isSelected;
  const isRadio = [apiTypes.RADIO, apiTypes.SELECT].includes(props.data.type);
  const isCheckbox = props.data.type === apiTypes.CHECK;

  return (
    <Option {...props}>
      <span
        className={classNames('icon-option', {
          'icon-option--selected': isSelected,
          'icon-option--rounded': isRadio,
        })}
      >
        {isSelected && isCheckbox && <VpIcon name="check" size={16} />}
      </span>
      {' '}
      {props.data.label}
    </Option>
  );
};
